export const buildUrlWithFromApp = (basePath: string): string => {
    const currentParams = new URLSearchParams(window.location.search);
    const isFromApp = currentParams.get('from_app') === 'true';
    const url = new URL(basePath, window.location.origin);
    if (isFromApp) {
        url.searchParams.set('from_app', 'true');
    }
    return url.toString();
};
